
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkAccountingPartnerTypeEnum } from '../models/work-accounting-partner-type-enum';

export function getUpdateAccountingPartnerDtoFormGroup() {
return new FormGroup({
    partnerType: new FormControl<WorkAccountingPartnerTypeEnum | undefined>(undefined),
    number: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    shortName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    address: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    iban: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    contactId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    defaultLedgerAccountId: new FormControl<number | undefined>(undefined),
    paymentConditionId: new FormControl<number | undefined>(undefined),
    paymentTermDays: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    discountPercent: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(100)]),
    discountDays: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      